<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="inner-wrap">
  <div class="find2-area">
    <div class="find-title">휴면회원 해제</div>

    <p class="f18 bold">고객님의 계정은 현재 휴면 상태입니다.</p>
    <p class="f15">휴면회원 해제를 위하여 본인인증을 진행해 주시기 바랍니다.</p>

    <div class="mt20 mb20 box">
      휴면계정이란?<br />
      정보통신망 이용촉진 및 정보보호 등에 관한 법률 제29조 및 동법 시행령 제16조에 따라 1년 또는 별도 지정한 기간 동안 로그인하지 않으신 경우 계정을 휴면으로 전환하고 개인정보를 별도로 분리하여 보관하는 것을 의미합니다.
    </div>

    <div class="mt40">
      <button class="hp-certification certification-btn" (click)="authCheck('H')"><span>휴대폰 인증</span></button>
      <button class="ipin-certification certification-btn" (click)="authCheck('I')"><span>아이핀 인증</span></button>
    </div>
  </div>
</div>

<app-footer></app-footer>